export default {"src":"/_next/static/media/giftbox.cb790c14.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};